import {
  Component,
  OnInit,
  Injectable,
  ViewChild,
  ElementRef,
  OnDestroy,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import '@angular/localize/init';
import { AppService } from './services/app.service';
import * as langConfig from './../assets/languageConfig/languageConfig.json';
import {
  Client,
  LongUrlResponse,
  ShortUrlRequest,
  StyleSettingsDealerLogo,
} from './services/client.service';
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  Event,
  RouterModule,
} from '@angular/router';
import { Subscription } from 'rxjs';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { TourGuideDialogComponent } from './tour-guide-dialog/tour-guide-dialog.component';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { DownloadPdfService } from './services/download-pdf.service';
import { MatMenuModule } from '@angular/material/menu';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { CarouselComponent } from './carousel/carousel.component';
import { VvrVehicleWalkthroughComponent } from './vvr-vehicle-walkthrough/vvr-vehicle-walkthrough.component';
import { VehicleWalkthroughComponent } from './vehicle-walkthrough/vehicle-walkthrough.component';
import { MatCardModule } from '@angular/material/card';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SettingsService } from './services/settings.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    MatMenuModule,
    RouterModule,
    TilesModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatIconModule,
    MatAccordion,
    VideoPlayerComponent,
    CarouselComponent,
    VvrVehicleWalkthroughComponent,
    VehicleWalkthroughComponent,
    MatDialogModule,
    MatCardModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTooltipModule,
  ],
})
@Injectable({
  providedIn: 'root',
})
export class AppComponent implements OnInit, OnDestroy {
  chooseLanguageText: string = $localize`Language selection`;
  languageTranslationInfoText: string = $localize`Choose a language option to view page in selected language`;
  navigationText: string = $localize`Navigation`;
  navigationInfoText: string = $localize`Click on home icon to navigate back to homepage`;
  title = 'incadea-enc-apps-spa';
  languageConfiguration: any = langConfig;
  currentLanguage: any;
  loader: boolean = false;
  dealerLogoDetails: StyleSettingsDealerLogo | undefined;
  private subscription!: Subscription;
  private routerEventsSubscription: Subscription | undefined;
  currentRoute: string = '';
  showHomeIcon: boolean = false;
  showDownloadIcon: boolean = false;
  token: string = '';
  pdfBase64Data: string = '';
  isPDFDataAvailable: boolean = true;
  showBackButton = false;

  @ViewChild('language') language!: ElementRef;
  @ViewChild('navigation') navigation!: ElementRef;
  schedulingOrderPdfBase64Data:string= "";
  quotePdfBase64Data:string= ""
  serviceOrderPdfBase64Data:string= ""

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    public client: Client,
    private route: ActivatedRoute,
    private router: Router,
    private pdfService: DownloadPdfService,
    private settingsService: SettingsService,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.setDefaultLanguage();
      let currentUrl = window.location.href;
      currentUrl = currentUrl.replace(/\/en-US\//i, '/');
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      if (!token) {
        const shortUrlRequest: ShortUrlRequest = { shortUrl: currentUrl };
        this.client.getLongUrl(shortUrlRequest).subscribe(
          (response: LongUrlResponse) => {
            if (response.longUrl) {
              window.location.href = response.longUrl;
              this.performTask();
            }
          },
          (error) => {
            this.appService.handleErrorMessage(error?.toString());
          }
        );
      } else {
        this.performTask();
      }
    }
  }
  performTask() {
    this.appService._loaderSubject.subscribe((data) => {
      //NG0100: ExpressionChangedAfterItHasBeenCheckedError. because of this issue, asigne operation moved to setTimeout function
      setTimeout(() => {
        this.loader = data;
      }, 0);
    });

    this.appService.languaTourGuide$.subscribe((response: string) => {
      let targetElementRect;
      const dialogConfig = new MatDialogConfig();
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
      if (response === 'vhr') {
        targetElementRect = this.language.nativeElement.getBoundingClientRect();
        this.language.nativeElement.classList.add('tour-dialog-indication');
        dialogConfig.position = {
          top: `${55}px`,
          left: `${targetElementRect.x - 240}px`,
        };
        dialogConfig.data = {
          title: this.chooseLanguageText,
          desciption: this.languageTranslationInfoText,
          stepCount: 1,
          totalSteps: 6,
        };
        setTimeout(() => {
          this.startTour(dialogConfig);
        }, 500);
      }
      else if (response === 'vhc-jobs') {
        targetElementRect = this.language.nativeElement.getBoundingClientRect();
        this.language.nativeElement.classList.add('tour-dialog-indication');
        dialogConfig.position = {
          top: `${55}px`,
          left: `${targetElementRect.x - 240}px`,
        };
        dialogConfig.data = {
          title: this.chooseLanguageText,
          desciption: this.languageTranslationInfoText,
          stepCount: 1,
          totalSteps: 4
        }
        setTimeout(() => {
          this.startVhcTour(dialogConfig);
        }, 500);
      }
      else if (response === 'Proforma-Invoice') {
        targetElementRect = this.language.nativeElement.getBoundingClientRect();
        this.language.nativeElement.classList.add('tour-dialog-indication');
        dialogConfig.position = {
          top: `${55}px`,
          left: `${targetElementRect.x - 240}px`,
        };
        dialogConfig.data = {
          title: this.chooseLanguageText,
          desciption: this.languageTranslationInfoText,
          stepCount: 1,
          totalSteps: 3
        }
        setTimeout(() => {
          this.startVhcTour(dialogConfig);
        }, 500);
      }
      else if (response === 'service-order') {
        targetElementRect = this.language.nativeElement.getBoundingClientRect();
        this.language.nativeElement.classList.add('tour-dialog-indication');
      
        dialogConfig.position = {
          top: '3.4375rem', 
          left: `${(targetElementRect.x - 240) / 16}rem`, 
        };
      
        dialogConfig.data = {
          title: this.chooseLanguageText,
          desciption: this.languageTranslationInfoText,
          stepCount: 1,
          totalSteps: 3
        }
        setTimeout(() => {
          this.startVhcTour(dialogConfig);
        }, 500);
      }
    });

    this.appService.navigationTourGuide$.subscribe((response: string) => {
      let targetElementRect;
      const dialogConfig = new MatDialogConfig();

      if (response === 'vhr') {
        window.scroll({
          top: 0,
          behavior: 'smooth',
        });

        targetElementRect =
          this.navigation.nativeElement.getBoundingClientRect();
        this.navigation.nativeElement.classList.add('tour-dialog-indication');
        dialogConfig.position = {
          top: `${55}px`,
          left: `${targetElementRect.x - 260}px`,
        };
        dialogConfig.data = {
          title: this.navigationText,
          desciption: this.navigationInfoText,
          stepCount: 6,
          totalSteps: 6,
        };
        setTimeout(() => {
          this.startTour(dialogConfig);
        }, 500);
      }
    });

    this.route.queryParams.subscribe((params: any) => {
      this.token = params['token'];
      if (this.token) {
        this.subscription = this.appService.siteSetting$.subscribe((state) => {
          this.dealerLogoDetails = state.dealerLogo;
          const flattenedStyleData = this.flattenStyleObject(state.style);
          this.setGlobalStyles(flattenedStyleData);
          const flattenedTitleData = this.flattenTitlesArray(state.titles);
          this.setGlobalStyles(flattenedTitleData);
        });
      }
    });

    this.routerEventsSubscription = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;

        this.showHomeIcon = false;
        this.showDownloadIcon = false;
        if (this.currentRoute.includes('/vhc-report/report')) {
          this.showHomeIcon = true;
          this.showDownloadIcon = true;
          this.getChecklistReport(this.token);
        } else if (this.currentRoute.includes('/vhc-report')) {
          this.showHomeIcon = true;
        }else if (this.currentRoute.includes('auth')) {
          this.showBackButton = true;
        }else {
          this.showBackButton = false;
        }
        
      });
  }

  ngOnDestroy(): void {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  setGlobalStyles(data: any): void {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        this.setPrimaryColor(key, data[key]);
      }
    }
  }

  goBack(): void {
    this.location.back();
  }
  
  flattenStyleObject(obj: any, parentKey: string = '', result: any = {}): any {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}-${key}` : key;
        if (Array.isArray(obj[key])) {
          obj[key].forEach((item: any, index: number) => {
            const buttonName = item.name.toLowerCase();
            this.flattenStyleObject(item, `${newKey}-${buttonName}`, result);
          });
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.flattenStyleObject(obj[key], newKey, result);
        } else {
          result[newKey] = obj[key];
        }
      }
    }
    return result;
  }

  flattenTitlesArray(titles: any): Record<string, string> {
    const flattenedResult: Record<string, string> = {};
    titles.forEach((title: any, index: number) => {
      const { type, content, page, style } = title;
      const titleKey = `titles-${page}-${type}`;
      Object.keys(style).forEach((prop) => {
        flattenedResult[`${titleKey}-style-${prop}`] = style[prop];
      });
    });

    return flattenedResult;
  }

  setPrimaryColor(key: string, value: string | null): void {
    if (typeof value === 'string' || value === null) {
      document.documentElement.style.setProperty(`--primary-${key}`, value);
    } else {
      throw new Error('Value must be a string or null');
    }
  }

  CurrentLanguage() {
    if (isPlatformBrowser(this.platformId)) {
      return window.localStorage.getItem('lang');
    }
    return null;
  }
  SwitchLanguage(lang: string) {
    window.localStorage.setItem('lang', lang);
  }

  setDefaultLanguage() {
    this.appService.setDefaultLanguage();
    this.changeDisplayLanguageCode();
    const pathSegments = window.location.pathname
      .split('/')
      .filter((seg) => seg);
    let currentLanguage = pathSegments[0];
    if (
      ['en-US', 'de-DE', 'es-MX', 'pt-PT', 'zh-CN', 'zh-TW'].includes(
        currentLanguage
      )
    ) {
      window.localStorage.setItem('lang', currentLanguage);
      this.changeDisplayLanguageCode();
    } else {
      let currentlang = this.CurrentLanguage();
      if (currentlang !== null) {
        this.changeDisplayLanguageCode();
        this.updateUrlLanguage(currentlang || 'en-US');
      }
    }
  }

  updateUrlLanguage(lang: string) {
   if(this.settingsService.isProduction){
    const currentUrl = new URL(window.location.href);
    let pathSegments = currentUrl.pathname.split('/').filter((seg) => seg);
    const supportedLanguages = [
      'en-US',
      'de-DE',
      'es-MX',
      'pt-PT',
      'zh-CN',
      'zh-TW',
    ];
    if (supportedLanguages.includes(pathSegments[0])) {
      pathSegments[0] = lang;
    } else {
      pathSegments.unshift(lang);
    }
    const newUrl = `${currentUrl.origin}/${pathSegments.join('/')}${
      currentUrl.search
    }`;
    window.location.href = newUrl;
  }
}

  changeLanguage(lang: string) {
    this.SwitchLanguage(lang);
    this.changeDisplayLanguageCode();
    this.updateUrlLanguage(lang);
  }

  changeDisplayLanguageCode() {
    if (isPlatformBrowser(this.platformId)) {
      let currentLanguage = localStorage.getItem('lang');
      if (currentLanguage) {
        for (let i of this.languageConfiguration.Langauges) {
          if (i.LanguageFileName == currentLanguage) {
            this.currentLanguage = i.LanguageCodeToDisplay;
            document.getElementsByClassName('Langtext')[0].innerHTML =
              this.currentLanguage;
            break;
          }
        }
      } else {
        this.currentLanguage = 'EN';
        document.getElementsByClassName('Langtext')[0].innerHTML =
          this.currentLanguage;
      }
    }
  }

  startTour(dialogConfig: MatDialogConfig<any>) {
    const dialogRef = this.dialog.open(TourGuideDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.language.nativeElement.classList.remove('tour-dialog-indication');
      this.navigation.nativeElement.classList.remove('tour-dialog-indication');
      this.appService.tourGuideStepPosition(result);;
    })
  }

  startVhcTour(dialogConfig: MatDialogConfig<any>){
    const dialogRef = this.dialog.open(TourGuideDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      this.language.nativeElement.classList.remove('tour-dialog-indication');
      this.appService.tourGuideStepPosition(result);
    });
  }
  
  downloadPDF() {
    switch (true) {
      case !!this.pdfBase64Data:
        this.pdfService.downloadPdf(this.pdfBase64Data, 'Vehicle-Health-Check-Report.pdf', 'application/pdf');
        break;
  
      case !!this.schedulingOrderPdfBase64Data:
        this.pdfService.downloadPdf(this.schedulingOrderPdfBase64Data, 'Scheduling-Order-Report.pdf', 'application/pdf');
        break;
  
      case !!this.quotePdfBase64Data:
        this.pdfService.downloadPdf(this.quotePdfBase64Data, 'Service-Quote-Report.pdf', 'application/pdf');
        break;
  
      case !!this.serviceOrderPdfBase64Data:
        this.pdfService.downloadPdf(this.serviceOrderPdfBase64Data, 'Service-Order-Report.pdf', 'application/pdf');
        break;
  
      default:this.isPDFDataAvailable = false;
        break;
    }
  }
  

  getChecklistReport(token: string) {
    if (this.showDownloadIcon) {
      this.appService.getPDFReport(token)?.subscribe((data: string) => {
        this.pdfBase64Data = data;
        this.isPDFDataAvailable = true;
      });
    }
  }

  getSchedulingOrderReport(token: string) {
    if (this.showDownloadIcon) {
      this.appService.getSchedulingOrderPDFReport(token)?.subscribe((data: string) => {
        this.schedulingOrderPdfBase64Data = data;
      })
    }
  }

  getQuoteReport(token: string) {
    if (this.showDownloadIcon) {
      this.appService.getQuotePDFReport(token)?.subscribe((data: string) => {
        this.quotePdfBase64Data = data;
      })
    }
  }

  getServiceOrderReport(token: string) {
    if (this.showDownloadIcon) {
      this.appService.getServiceOrderPDFReport(token)?.subscribe((data: string) => {
        this.serviceOrderPdfBase64Data = data;
      })
    }
  }

}
